export default __webpack_public_path__ + "static/media/grafema_gim-tonico_02.1d65bcd6.mp4";